import { Badge } from '@repo/ui';

/** A small count beside a navigation label; nothing at zero, because "0 open" is noise. */
export function NavCountBadge({ count }: { count: number }) {
  if (count <= 0) return null;

  return (
    <Badge
      variant="destructive"
      role="status"
      aria-label={`${count} open`}
      className="ml-1.5 px-1.5 py-0 text-[11px] leading-5"
    >
      {count}
    </Badge>
  );
}
